
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.228 16.913a2.22 2.22 0 010 2.974c-2.33 2.508-7.635 7.391-13.828 7.391S4.902 22.395 2.572 19.887a2.22 2.22 0 010-2.974C4.902 14.405 10.207 9.52 16.4 9.52s11.498 4.884 13.828 7.392z","stroke":"#339299","stroke-width":"2.22","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.402 22.839a4.44 4.44 0 100-8.879 4.44 4.44 0 000 8.879z","stroke":"#339299","stroke-width":"2.22","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    